import React from "react";
import classnames from "classnames";
import { getSize } from "../../utils/size";
import { isFunction } from "lodash";

export const getStyle = (color = "primary") => {
  return color.toLowerCase();
};

export const Button = ({
  label,
  color, // primary, secondary, line, gray, text, green, red
  // success, danger, warning, info, light, dark,
  style = {},
  size = "md", // lg, md, sm ,x-sm, tiny
  disabled = false,
  hover = false,
  action,
  onClick,
  className,
  children,
  data,
}) => {
  const _action = () => {
    if (action) return action;
    if (onClick) return onClick;
    return () => { };
  };

  const getChilren = () => {
    let child = children;
    if (children && isFunction(children)) {
      child = children();
    }
    return child;
  };

  return (
    <button
      style={style}
      type="button"
      onClick={_action()}
      className={classnames(`btn btn-${getStyle(color)} btn-${getSize(size)}`, {
        "btn-hover": hover,
        [className]: className,
      })}
      disabled={isFunction(disabled) ? disabled(data) : disabled}
    >
      {label || getChilren() || "버튼"}
    </button>
  );
};

export default Button;
